export const CompanyImageType = {
    Logo: 'logo',
    Mail: 'mail',
    Favicon: 'favicon'
};

export const CompanyImageTypeFallback = {
    FullLogo: 'logo',
    LogoWithoutText: 'logo-without-text',
    MailLogo: 'mail-logo',
    Favicon: 'favicon',
};
